module.exports = __webpack_public_path__ + "static/media/sql.fb220823.svg";